export default "__VITE_ASSET___jIFZbJs__"